export default [
  {
    path: '/admin/payroll-calculations',
    name: 'payroll-calculation',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payroll/payroll-calculation/index.vue')
  }
]
